<template>
    <div v-show="logueado" id="destinatarios" class="container">
        <div id="crear" v-if="crear" class="separador contenido br-2-blue">
            <form @submit.prevent="button">
                <h3 v-if="editarDestinatario" class="text-center">Editar nombres asociados a mi casillero</h3>
                <h3 v-else class="text-center">Crear nombres asociados a mi casillero</h3>
                <p class="text-center text-danger font-weight-bold">Todos los campos (*) son obligatorios</p>
                <div class="container-flex">
                    <div class="column">
                        <h4>Datos Personales y Correo Electrónico:</h4>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Tipo de identificación *</label>
                                <select class="form-control" v-model="userData.tipo_de_identificacion_id" name="eTipoIdentificacion" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('eTipoIdentificacion') }">
                                    <option 
                                    v-for="identificacion in tiposDeIdentificacion"
                                    v-bind:key="identificacion.id"
                                    :value="identificacion.id"
                                    >{{ identificacion.descripcion }}</option>
                                </select>
                                <span v-show="errors.has('eTipoIdentificacion')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Número de identificación</label>
                                <input name="numero_de_identificacion" v-model="userData.numero_de_identificacion" class="form-control" placeholder="Nit o numero de identificacion" type="text" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Primer nombre *</label>
                                <input id="primer_nombre" name="primer_nombre" v-model="userData.primer_nombre" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('primer_nombre') }" class="form-control" placeholder="Primer nombre" type="text" />
                                <span v-show="errors.has('primer_nombre')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Segundo nombre</label>
                                <input name="segundo_nombre" v-model="userData.segundo_nombre" class="form-control" placeholder="Segundo nombre" type="text" />
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Primer apellido *</label>
                                <input name="primer_apellido" v-model="userData.primer_apellido" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('primer_apellido') }" class="form-control" placeholder="Primer apellido" type="text" />
                                <span v-show="errors.has('primer_apellido')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Segundo apellido</label>
                                <input name="segundo_apellido" v-model="userData.segundo_apellido" class="form-control" placeholder="Segundo apellido" type="text" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Email *</label>
                                <input v-validate="'required'" v-model="userData.email" name="email" type="email" :class="{'is-danger': errors.has('email')}" placeholder="Email" ref="email" class="form-control" />
                                <span v-show="errors.has('email')" class="small help text-danger">No es un email válido</span>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Confirmación email *</label>
                                <input v-validate="'required|confirmed:email'" name="email_confirmation" type="email" :class="{'is-danger': errors.has('email_confirmation')}" placeholder="Confirmar email" data-vv-as="email" v-model="userData.confirm_email" class="form-control" />
                                <span v-show="errors.has('email_confirmation')" class="small help text-danger">El email no coincide</span>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <h4>Ubicación y Teléfonos:</h4>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label>País *</label>
                                <select class="form-control" v-model="selectPais" v-on:change="getEstados(selectPais)" name="ePais" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('ePais') }">
                                    <option v-for="pais in paises" :value="pais.codigo" v-bind:key="pais.codigo">{{pais.nombre}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Departamento *</label>
                                <select class="form-control" v-model="selectEstado" v-on:change="getCiudades(selectEstado)" name="eEstado" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('eEstado') }">
                                    <option
                                    v-for="estado in estados"
                                    :value="estado.id"
                                    v-bind:key="estado.id"
                                    >{{estado.nombre}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Ciudad *</label>
                                <select class="form-control" v-model="selectCiudad" name="eCiudad" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('eCiudad') }">
                                    <option
                                    v-for="ciudad in ciudades"
                                    :value="ciudad.id"
                                    v-bind:key="ciudad.id"
                                    >{{ciudad.nombre}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Dirección *</label>
                                <input name="direccion" v-model="userData.direccion" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('direccion') }" class="form-control" placeholder="Dirección" type="text" />
                                <span v-show="errors.has('direccion')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Barrio</label>
                                <input name="barrio" v-model="userData.barrio" class="form-control" placeholder="Barrio" type="text" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-lg-6">
                                <label>Télefono fijo</label>
                                <input name="telefono_fijo" v-model="userData.telefono_fijo" class="form-control" placeholder="Teléfono fijo" type="text" />
                            </div>
                            <div class="form-group col-md-12 col-lg-6">
                                <label class="mt-1 mb-0 ml-1">Teléfono celular *</label>
                                <input name="telefono_celular" v-model="userData.telefono_celular" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('telefono_celular') }" class="form-control" placeholder="Teléfono celular" type="text" />
                                <span v-show="errors.has('telefono_celular')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row estado">
                    <div class="form-group col-md-4">
                        <template>
                            <div>
                                <label>Estado</label>
                                <b-form-checkbox v-model="userData.activo" name="check-button" switch></b-form-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12 text-center">
                        <a
                            class="btn btn-dark"
                            @click="closeCrear()"
                            role="button"
                            href="#"
                        >Cancelar</a>
                        <button class="btn btn-blue ml-4">Guardar</button>
                    </div>
                </div>
            </form>
        </div>
        <div v-if="!crear"  id="listar" class="separador contenido br-2-blue">
            <h2 class="text-center">Nombres asociados a mi casillero</h2><br/>
            <div class="panel panel-default">
            <div class="wrapper">
                <form class="form ng-pristine ng-valid">
                <div class="row">
                    <div class="col-md-3 col-sm-5 col-xs-6">
                    <a class="btn btn-blue" @click="toogle()" role="button" href="#"><b-icon icon="person-plus-fill" aria-hidden="true"></b-icon> Crear</a>
                    </div>
                    <div class="col-md-6 col-sm-4 col-xs-6">
                    <div class="form-row">
                        <div class="form-group col-md-3 col-lg-2">
                        <label>Registros</label>
                        </div>
                        <div>
                        <select
                            class="form-control"
                            name="registros"
                            v-validate="'required'"
                            @change="changePage()"
                            :class="{ 'is-invalid': submitted && errors.has('registros') }"
                            v-model="registros"
                        >
                            <option selected="selected" value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-2 col-sm-3 col-xs-12">
                    <input
                        type="text"
                        class="w-full app-input-group__m-t-xs form-control"
                        v-on:keyup="changePage"
                        placeholder="Buscar"
                        v-model="filtro"
                    />
                    </div>
                </div>
                </form>
            </div>
            <br />
            <div class="table-responsive app-table">
                <table class="table table-striped b-t table-color" id="my-table">
                <thead>
                    <tr>
                    <th>Opciones</th>
                    <th>Estado</th>
                    <th>SubCasillero</th>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th>País</th>
                    <th>Departamento / Estado</th>
                    <th>Ciudad</th>
                    <th>Teléfono</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="destinatario in destinatarios" v-bind:key="destinatario.id">
                    <td>
                        <div class="row m-0 options">
                        <span v-on:click="editar(destinatario)" title="Editar" class="ml-2">
                            <b-icon icon="pencil-fill" aria-hidden="true"></b-icon>
                        </span>
                        <span v-on:click="inactivar(destinatario)" v-if="destinatario.activo" class="ml-2" title="Inactivar destinatario">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-person-slash" style="font-size: 25px;" viewBox="0 0 16 16">
                            <path d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                            </svg>
                        </span>
                        </div>
                    </td>
                    <td>
                        <span v-if="destinatario.activo">Activo</span>
                        <span v-else>Inactivo</span>
                    </td>
                    <td class="ng-binding">{{destinatario.sub_casillero}}</td>
                    <td>{{destinatario.nombre_completo}}</td>
                    <td class="ng-binding">{{destinatario.direccion}}</td>
                    <td class="ng-binding">{{destinatario.pais.nombre}}</td>
                    <td class="ng-binding">{{destinatario.departamento.nombre}}</td>
                    <td class="ng-binding">{{destinatario.ciudad.nombre}}</td>
                    <td class="ng-binding">{{destinatario.telefono_celular}}</td>
                    </tr>
                    <tr v-if="destinatarios.length == 0 && !cargando">
                        <td colspan="9" class="text-center">No hay resultados</td>
                    </tr>
                </tbody>
                </table>
                <div v-show="cargando" class="text-center app-bkg-color-f5 app-no-data-table b-t" >
                    <Cargando/>
                </div>
            </div>
            <div class="panel-footer">
                <b-pagination
                v-model="actualPagina"
                :total-rows="totalRegistros"
                :per-page="registros"
                aria-controls="my-table"
                align="right"
                v-on:input="changePage"
                ></b-pagination>
            </div>
            </div>
        </div>
  </div>
</template>

<script>
import { getSelectedEnvironment, api } from "../plugins/api_conect";
import Cargando from '../layouts/Cargando.vue';

const currentEnvironment = getSelectedEnvironment();

export default {
    computed: {
        logueado() {
            return this.$store.getters.loggedIn;
        }
    },
    components: {
      Cargando
    },
    methods: {
        button() {
            if (this.editarDestinatario) {
                this.submitEdit();
            } else {
                this.submit();
            }
        },
        clean() {
            this.userData.primer_nombre = "";
            this.userData.primer_apellido = "";
            this.userData.segundo_nombre = "";
            this.userData.segundo_apellido = "";
            this.userData.tipo_de_identificacion_id = "";
            this.userData.numero_de_identificacion = "";
            this.userData.email = "";
            this.userData.confirm_email = "";
            this.userData.telefono_celular = "";
            this.userData.telefono_fijo = "";
            this.userData.direccion = "";
            this.userData.pais_codigo = "";
            this.userData.departamento_id = "";
            this.userData.ciudad_id = "";
            this.userData.codigo_postal_id = "";
            this.userData.barrio = "";
            this.selectPais = "";
            this.selectEstado = "";
            this.selectCiudad = "";
        },
        getPaises: function() {
            api()
                .get(`/api/casillero/clientes/getCountries/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    this.paises = data.filter(pais => { return pais.activo; });
                    if (this.pais) {
                        const indexPais = this.paises.findIndex(
                            x => x.codigo === this.pais.codigo
                        );

                        if (indexPais !== -1) {
                          this.selectPais = this.paises[indexPais].codigo;
                          this.getEstados(this.selectPais);
                        } else {
                          this.estados = null;
                          this.ciudades = null;
                          this.selectEstado = "";
                          this.selectCiudad = "";
                        }
                    }
                }, () => {
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los paises', 'error')
                }).catch(err => {
                  console.error(err)
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los estados', 'error')
                });
        },
        getEstados: function(codigoPais) {
            api()
                .get(`api/casillero/clientes/getDepartaments/${codigoPais}/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    if (data.length > 0) {
                        this.estados = data;

                        if (this.estado) {
                            const indexEstado = this.estados.findIndex(
                                x => x.id === this.estado.id
                            );

                            if (indexEstado !== -1) {
                              this.selectEstado = this.estados[indexEstado].id;
                              this.getCiudades(this.selectEstado);
                            } else {
                              this.ciudades = null;
                              this.estado = null;
                            }
                        }
                    } else {
                        this.estado = null;
                        this.estados = null;
                        this.ciudades = null;
                        this.selectEstado = "";
                        this.selectCiudad = "";
                    }
                }, () => {
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los estados', 'error')
                }).catch(err => {
                  console.error(err)
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los estados', 'error')
                });
        },
        getCiudades: function(idEstado) {
            api()
                .get(`/api/casillero/clientes/getCities/${idEstado}/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    if (data.length > 0) {
                        this.ciudades = data;

                        if (this.estado) {
                            const indexCiudad = this.ciudades.findIndex(
                                x => x.id === this.ciudad.id
                            );

                            if (indexCiudad !== -1) {
                              this.selectCiudad = this.ciudades[indexCiudad].id;
                            } else {
                              this.ciudades = null;
                              this.selectCiudad = "";
                            }
                        }
                    } else {
                        this.ciudades = null;
                        this.selectCiudad = "";
                    }
                }, () => {
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener las ciudades', 'error')
                }).catch(err => {
                  console.error(err)
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los estados', 'error')
                });
        },
        getTiposIdentificacion() {
            api()
                .get(`/api/tiposdeidentificacion/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    this.tiposDeIdentificacion = data;

                    if (this.tiposDeIdentificacion) {
                        this.tiposDeIdentificacion = data.datos;
                    }
                }, () => {
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los tipos de identificacion', 'error')
                }).catch(err => {
                  console.error(err)
                  this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los estados', 'error')
                });
        },
        submitEdit() {

            this.submittedEdit = true;
            
            this.$validator.validate().then(valid => {
                if (valid) {
                    let pais_codigo = this.selectPais ?? "";
                    let departamento_id = this.selectEstado ?? "";
                    let ciudad_id = this.selectCiudad ?? "";

                    if (this.userData["numero_de_identificacion"] == "") {
                        this.userData.tipo_de_identificacion_id = "";
                    }

                    let datos = this.userData;
                    datos["pais_codigo"] = pais_codigo;
                    datos["departamento_id"] = departamento_id;
                    datos["ciudad_id"] = ciudad_id;
                    datos["cliente_id"] = localStorage.getItem('cliente_id');

                    api().post(`/api/casillero/destinatarios/${this.id}`, datos, {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                'Authorization': `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`
                            },

                        })
                        .then((response) => {
                            const { data } = response;
                            this.responseMessage = data["msg"];
                            this.$swal(
                                "Proceso Completado",
                                "Registro actualizado exitosamente",
                                "success"
                            );
                            this.changePage();
                            this.crear = false;
                            this.editarDestinatario = false;

                            this.checked = true;
                            this.clean();

                        }).catch(async (error) => {

                            if (error.response.status === 401) {
                                await this.$auth.refreshToken();
                                this.submitEdit();
                            } else {
                                for (let err in error.response.data["errores"]) {
                                    this.responseMessage += ". ";
                                    this.responseMessage += error.response.data["errores"][err];
                                }
                                this.checked = true;
                                this.clean();
                            }
                        });
                }
            });
        },
        editar(destinatario) {
            this.pais = destinatario.pais;
            this.estado = destinatario.departamento;
            this.ciudad = destinatario.ciudad;
            this.userData = destinatario;
            this.userData.confirm_email = destinatario.email;
            this.crear = true;
            this.editarDestinatario = true;
            this.id = destinatario.id;
            this.getPaises();
        },
        inactivar(objeto) {
            objeto.activo  = false;
            api()
                .post(`/api/casillero/destinatarios/${objeto.id}`, objeto, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`,
                    },
                })
                .then((response) => {
                    const { data } = response;
                    this.responseMessage = data["msg"];
                    this.changePage();
                    this.$swal(
                        "Proceso completado",
                        "Registro inactivado con éxito",
                        "success"
                    );

                }).catch(async (error) => {
                    if (error.response.status === 401) {
                        await this.$auth.refreshToken();
                        this.inactivar(objeto);
                    } else {
                        for (let err in error.response.data["errores"]) {
                            this.responseMessage += ". ";
                            this.responseMessage += error.response.data["errores"][err];
                        }
                        this.checked = true;
                    }
                });
        },
        toogle() {
            this.crear = true;
        },
        closeCrear() {
            this.crear = false;
            this.clean();
            this.changePage();
        },
        closeEdit() {
            this.editarDiv = false;
        },
        changePage() {
            this.destinatarios = [];
            this.cargando = true;

            var datos = {
                str_busqueda: this.filtro,
                pageSize: this.registros
            };

            api().post(`/api/casillero/clientes/destinatarios?page=${this.actualPagina}`, datos, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.token_type} ${localStorage.access_token}`
                    },
                })
                .then((response) => {
                    const { data } = response;

                    if (data["datos"] != null) {
                        this.destinatarios = data["datos"]["data"];
                        this.totalRegistros = data["datos"]["total"];
                        this.totalPaginas = data["datos"]["last_page"];
                        this.actualPagina = data["datos"]["current_page"];
                        this.authenticated = true;
                        this.cargando = false;
                    }
                }, async err => {
                    if (err.response.status === 401) {
                        await this.$auth.refreshToken();
                        this.changePage();
                        this.getPaises();
                    } else {
                        this.$swal(
                            "Error",
                            err,
                            "error"
                        );
                    }
                }).catch( () => {
                    this.$swal("Error", "Ha ocurrido un error en el sistema", "error");
                });
        },
        submit: function() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    if (this.selectPais) {
                        var pais_codigo = this.selectPais;
                    } else {
                        pais_codigo = "";
                    }
                    if (this.selectEstado) {
                        var departamento_id = this.selectEstado;
                    } else {
                        pais_codigo = "";
                    }
                    if (this.selectCiudad) {
                        var ciudad_id = this.selectCiudad;
                    } else {
                        pais_codigo = "";
                    }

                    if (this.userData["numero_de_identificacion"] == "") {
                        var tipo_de_identificacion_id = "";
                    } else {
                        tipo_de_identificacion_id = parseInt(this.selectIdentificacion);
                    }

                    let datos = this.userData;
                    datos["pais_codigo"] = pais_codigo;
                    datos["departamento_id"] = departamento_id;
                    datos["ciudad_id"] = ciudad_id;
                    datos["tipo_de_identificacion_id"] = tipo_de_identificacion_id;
                    datos["cliente_id"] = localStorage.getItem('cliente_id');

                    api().post(`/api/casillero/destinatarios`, datos, {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                            },
                        })
                        .then((response) => {
                            const { data } = response;
                            this.responseMessage = data["msg"];
                            this.$swal(
                                "Proceso completado",
                                "Registro creado exitosamente",
                                "success"
                            );
                            this.clean();
                            this.crear = false;
                            this.changePage();

                        }).catch(async (error) => {
                            if (error.response.status === 401) {
                                await this.$auth.refreshToken();
                                this.submit();
                            } else {
                                for (let err in error.response.data["errores"]) {
                                    this.responseMessage += ". ";
                                    this.responseMessage += error.response.data["errores"][err];
                                }
                            }

                        });
                }
            });
        }
    },
    data() {
        return {
            authenticated: false,
            cargando: false,
            submitted: false,
            submittedEdit: false,
            showEdit: false,
            responseMessage: "",
            checked: false,
            userData: {
                primer_nombre: "",
                primer_apellido: "",
                segundo_nombre: "",
                segundo_apellido: "",
                tipo_de_identificacion_id: "",
                numero_de_identificacion: "",
                email: "",
                confirm_email: "",
                telefono_celular: "",
                telefono_fijo: "",
                direccion: "",
                pais_codigo: "",
                departamento_id: "",
                ciudad_id: "",
                codigo_postal_id: "",
                barrio: "",
                activo: true
            },
            registros: 10,
            actualPagina: 1,
            totalPaginas: 0,
            totalRegistros: 0,
            filtro: "",
            destinatarios: [],
            crear: false,
            editarDiv: false,
            editarDestinatario: false,
            paises: null,
            estados: null,
            ciudades: null,
            selectPais: null,
            selectEstado: null,
            selectCiudad: null,
            tiposDeIdentificacion: null,
            pais: null,
            estado: null,
            ciudad: null,
            id: ""
        };
    },
    mounted: function() {
        this.changePage();
        this.getPaises();
        this.getTiposIdentificacion();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenido {
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 15px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    background-color: white;
}
.table-color {
    color: black !important;
    background: aliceblue !important;
}
.options {
    cursor: pointer;
    :hover{
        color: var(--primary-color) !important;
    }
}
.estado {
    padding-left: 25px;
    cursor: pointer;
}
</style>